module.exports = ".popup {\n  width: 320px;\n  max-width: 100%;\n  text-align: center; }\n\nh5 {\n  font-weight: 700;\n  margin-bottom: 10px; }\n\ninput, select,\n.btn {\n  width: 100%; }\n\n.btn {\n  margin-top: 5px; }\n\np {\n  margin-top: 10px; }\n\n.route-label {\n  cursor: pointer; }\n\n.route-label * {\n  cursor: pointer; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/message/profile-popup/profile-popup.component.scss
// module id = 925
// module chunks = 0